import en from '@/i18n/config/english.json'
import tw from '@/i18n/config/tw.json'
import th from '@/i18n/config/thai.json';
import fr from '@/i18n/config/french.json';
import ja from '@/i18n/config/ja.json';
import zh from '@/i18n/config/zh.json'
import pt_rbr from '@/i18n/config/portuguese.json'
import variable from '@/i18n/config/id.json';

// import lang from '@/locales/config/variable.js'

export default {
  en,
  tw,
  th,
  fr,
  ja,
  zh,
  pt_rbr,
  variable
  // lang
}